// removed by extract-text-webpack-plugin
module.exports = {"yAxis":"_2ebk"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/LandingPage/Chart/YAxis/styles.scss
// module id = 438
// module chunks = 0